import { SVGProps } from "react";

export default function UserGlobeIcon(props: SVGProps<SVGSVGElement>) {
  const { height = 20, width = 20, stroke = "#333333", ...rest } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M12.4484 6.69974C12.6318 7.06641 12.7401 7.48307 12.7401 7.92474C12.7318 9.39974 11.5734 10.6081 10.1068 10.6497C10.0484 10.6414 9.97344 10.6414 9.90677 10.6497C8.4401 10.5997 7.27344 9.39974 7.27344 7.92474C7.27344 6.41641 8.4901 5.19141 10.0068 5.19141"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.6161 16.1498C14.1328 17.5081 12.1661 18.3331 9.99948 18.3331C7.83281 18.3331 5.86615 17.5081 4.38281 16.1498C4.46615 15.3665 4.96615 14.5998 5.85781 13.9998C8.14115 12.4831 11.8745 12.4831 14.1411 13.9998C15.0328 14.5998 15.5328 15.3665 15.6161 16.1498Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.33073 5.00033C2.28906 6.39199 1.66406 8.12533 1.66406 10.0003C1.66406 14.6003 5.3974 18.3337 9.9974 18.3337C14.5974 18.3337 18.3307 14.6003 18.3307 10.0003C18.3307 5.40033 14.5974 1.66699 9.9974 1.66699C8.80573 1.66699 7.66406 1.91699 6.63906 2.37533"
        stroke="#292D32"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
